<!-- 统计 -->
<template>
    <div class='container'>
        <header class="header">
            <p class="headerP1">筛选</p>
            <div style="height:0.34rem;border-right:1px solid #ED7046;width: 1px;margin-right: 0.24rem;"></div>
            <el-select style="margin-right: 0.1rem;" size="small" v-model="tableType" placeholder="请选择">
                <el-option v-for="item in tableNameList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
            <el-input size="small" style="width: 1.2rem;margin-right: 0.1rem;" v-model="init.q.userNumber" placeholder="人数"
                type="number"></el-input>
            <el-input size="small" style="width: 1.2rem;margin-right: 0.1rem;" v-model="init.q.planDay" placeholder="天数"
                type="number"></el-input>
            <cityAutocomplete :action="false" @handleSelect="handleSelect" nameProName="destination" :obj="init.q"
                :searchType="2" sizeType="small"></cityAutocomplete>
            <el-date-picker @change="selectDate" size="small" style="margin: 0 0.1rem;" v-model="dateArr"
                value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期"
                end-placeholder="结束日期">
            </el-date-picker>
            <el-checkbox style="margin:0 0.15rem;" v-model="checked">首次入境国家</el-checkbox>
            <el-button size="small" @click="init.page = 1, getData()" type="primary" icon="el-icon-search">查询</el-button>
            <el-button size="small" @click="resetClick" icon="el-icon-search">重 置</el-button>
        </header>
        <el-table :summary-method="getSummaries" border :header-cell-style="{
            backgroundColor: '#FDEFE7', color: '#000000'
        }" v-loading="loading" :data="tableData" show-summary style="width: 100%">
            <el-table-column align="center" prop="planId" label="团号">
            </el-table-column>
            <el-table-column sortable align="center" prop="planName" label="行程名称">
            </el-table-column>
            <el-table-column sortable align="center" prop="userNumber" label="人数">
            </el-table-column>
            <el-table-column align="center" label="日期">
                <template slot-scope="scope">
                    {{ scope.row.departureDate }} 至 {{ scope.row.endDate }}
                </template>
            </el-table-column>
            <el-table-column width="250" class-name="column4" align="center" label="国家名称">
                <template slot-scope="scope">
                    <div v-if="scope.row.countryNames.length > 0">
                        <div class="tableTd"
                            v-for="(n, m) in checked ? [scope.row.countryNames[0]] : scope.row.countryNames" :key="m">
                            <p style="width: 1rem;text-align: left;padding-left: 0.1rem;">{{ n.countryName }}</p> {{
                                n.startDate
                            }} 至 {{ n.endDate }}
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column align="center" class-name="column4" label="入境国家的人天数">
                <template slot-scope="scope">
                    <div v-if="scope.row.countryNames.length > 0">
                        <div class="tableTd"
                            v-for="(n, m) in checked ? [scope.row.countryNames[0]] : scope.row.countryNames" :key="m">
                            <p style="margin: 0 auto;">{{ scope.row.userNumber * n.number }}</p>
                        </div>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <Pagination :currentPage="init.page" :parentPageSize="10" :totalNumber="AllpagesNum" @loadTable='loadTable'>
        </Pagination>
    </div>
</template>

<script>
import Pagination from '@/components/Pagination.vue'
import cityAutocomplete from '../common/cityAutocomplete.vue'
import Api from "../../components/Api/PlanApi";
import { days } from '@/assets/utils/unit'
export default {
    components: { Pagination, cityAutocomplete },
    data() {
        return {
            value: "",
            value1: '',
            tableType: '接待数据统计表',
            AllpagesNum: 0,
            loading: false,
            days,
            checked: false,//勾选首次入境国家
            tableNameList: [{
                label: '接待数据统计表',
                value: 0
            }],
            tableData: [],
            dateArr: [],
            init: {
                "page": 1,
                "q": {
                    "userNumber": "",
                    "planDay": "",
                    "startDate": "",
                    "endDate": "",
                    "destination": "",
                },
                "size": 10
            },
        }
    },
    computed: {},
    watch: {},
    methods: {
        handleSelect(val) {
            this.init.q.destination = val.countryNameCn
            this.getData()
        },
        //选择日期
        selectDate(val) {
            if (!val) {
                this.init.q.startDate = ''
                this.init.q.endDate = ''
                this.getData()
                return
            }
            this.init.q.startDate = val[0]
            this.init.q.endDate = val[1]
            this.getData()
        },
        getData() {
            this.loading = true
            new Api('plan').planCountryList(this.init).then((res) => {
                if (res.status === 200) {
                    this.tableData = res.data.records
                    this.AllpagesNum = res.data.total
                    this.loading = false
                } else {
                    this.$message({ type: "error", message: res.statusText })
                    this.loading = false
                }
            }).catch((err) => {
                this.$message({ type: "error", message: '加载失败！' })
                this.loading = false
            })
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '总计';
                    return;
                }
                let values
                if (index === 5) {
                    values = data.reduce((acc, item) => {
                        if (Array.isArray(item.countryNames) && item.countryNames.length > 0) {
                            const multipliedNumbers = (this.checked ? [item.countryNames[0]] : item.countryNames).map(n => item.userNumber * n.number);
                            return acc.concat(multipliedNumbers);
                        } else {
                            return acc;
                        }
                    }, []);
                } else if (index === 2) {
                    values = data.map(item => Number(item[column.property]));
                }
                if (values && !values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                    sums[index]
                }
            });
            return sums;
        },
        resetClick() {
            this.init.q = {
                "userNumber": "",
                "planDay": "",
                "startDate": "",
                "endDate": "",
                "destination": "",
            }
            console.log(this.init,'asdasdsadsda');
            this.init.page = 1
            this.dateArr = []
            this.getData()
        },
        loadTable(page, size) {
            this.init.size = size
            this.init.page = page
            this.getData()
        },
    },
    created() {

    },
    mounted() {
        this.getData()
    },
}
</script>
<style lang='scss' scoped>
/deep/ .el-table .column4 {
    padding: 0;
}

/deep/ .el-table .column4 .cell {
    padding: 0;
}

.tableTd {
    border-bottom: 0.01rem solid #EBEEF5;
    padding: 0.12rem 0;
    display: flex;
    align-items: center;

    &:nth-last-child(1) {
        border-bottom: none;
    }
}

.container {
    .header {
        display: flex;
        align-items: center;
        color: #ED7046;
        margin-bottom: 0.2rem;
        background-color: #fff;
        height: 0.6rem;
        border-radius: 0.1rem;
        padding: 0 0.3rem;
        margin-bottom: 0.12rem;

        .headerP1 {
            margin-right: 0.2rem;
        }
    }
}
</style>